/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionsTypes from './DeleteItem-ActionTypes';

export const deleteItem = (orderItemId, isPassport, history, typeOrderItem, positionItem, skuCode, parentSku, typeGreetingCard = '', orderCartItemId, callback) => ({
    type: actionsTypes.DELETE_ITEM,
    data: {
        orderItemId,
        isPassport,
        history,
        typeOrderItem,
        positionItem,
        skuCode,
        parentSku,
        typeGreetingCard,
        orderCartItemId,
        callback,
    },
});

export const deleteItemFood = (orderItemId, isPassport, history, page, skuCode, parentSku) => ({
    type: actionsTypes.HANDLE_DELETE_ITEM_FOOD,
    data: {
        orderItemId,
        isPassport,
        history,
        page,
        skuCode,
        parentSku,
    },
});

export const enterpriseDeleteItem = (orderItemId, isPassport, history, typeOrderItem, positionItem, skuCode, parentSku, type, orderCartItemId, handleCallback) => ({
    type: actionsTypes.ENTERPRISE_DELETE_ITEM,
    data: {
        orderItemId,
        isPassport,
        history,
        typeOrderItem,
        positionItem,
        skuCode,
        parentSku,
        type,
        orderCartItemId,
        handleCallback,
    },
});

export default {};
